import React, { useState } from 'react';
import './view-brand-lift-study.scss';
import { DashboardHeader } from '../../atoms';
import { ViewBlsData, DashContentFooter } from '../../molecules';
import { DashboardContext } from '../../../context';
import { useHistory } from 'react-router-dom';


function ViewBrandLiftStudy() {
    const history = useHistory();
  const [dashData, setDashData] = useState({});  

  const handleBackClick = () => {
    history.push('/bls_insights');
  };
      return (
        <DashboardContext.Provider value={{ dashData, setDashData }}>
          <div className='row no-gutters'>
            <div className='no-gutters dash-left-wrapper'>
              <DashboardHeader />
              <ViewBlsData handleBackClick={() => handleBackClick()}/>
              <DashContentFooter />
            </div>
    
          </div>
    
        </DashboardContext.Provider>
      );
}

export default ViewBrandLiftStudy;

